import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import {makeStyles} from '@mui/styles';
import React from 'react';
import {theme} from '../../Theme';

interface IProps {
  items: any[];
  id?: any;
  name?: string;
  label?: string;
  value?: any;
  defaultValue?: any;
  disabled?: boolean;
  fullWidth?: boolean;
  gutterBottom?: boolean;
  inverted?: boolean;
  helperText?: any;
  style?: any;
  onChange?: any;
  MenuProps?: any;
}

const useStyles = (props: IProps) =>
  makeStyles(() => ({
    select: {
      '&.MuiFilledInput-root': {
        height: 36,
        borderRadius: 22,
        border: props.helperText
          ? `1px solid ${theme.palette.red.main}`
          : `1px solid ${theme.palette.gray.main}`,
        backgroundColor: props.helperText
          ? theme.palette.red.light
          : props.inverted
            ? theme.palette.secondary.main
            : theme.palette.gray.main,

        '&:hover': {
          border: `1px solid ${theme.palette.primary.light}`,
        },
        '&:before': {
          borderBottom: 'none !important',
        },
        '&:after': {
          borderBottom: 'none !important',
        },

        '& .MuiFilledInput-input': {
          display: 'flex',
          alignItems: 'center',
          height: 36,
          padding: '0px 12px',
          fontSize: 14,
          fontFamily: 'AeonikProReqular, sans-serif',
        },
        opacity: props.disabled ? '75%' : '100%',
      },
    },
  }));

export default function BidmiiSelect(props: IProps) {
  const classes = useStyles(props)();

  return (
    <FormControl
      variant="standard"
      style={{width: props.fullWidth ? '100%' : 'auto'}}>
      {props.label && (
        <Typography
          variant="subtitle2"
          align="left"
          style={{fontSize: 12, marginBottom: 2}}>
          {props.label}
        </Typography>
      )}
      <Select
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={props.onChange}
        variant="filled"
        className={classes.select}
        style={{
          ...props.style,
          height: 36,
          marginBottom: props.gutterBottom ? 12 : 0,
          paddingRight: 20,
        }}
        MenuProps={props.MenuProps}>
        {props.items.map((item, i) => (
          <MenuItem
            key={item?.value ? i : item}
            value={item?.value ? item.value : item}>
            {item.value ? item.label : item}
          </MenuItem>
        ))}
      </Select>
      {props.helperText && (
        <Typography
          variant="caption"
          style={{color: theme.palette.red.dark, marginLeft: 14}}>
          {props.helperText}
        </Typography>
      )}
    </FormControl>
  );
}
